<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Product Type
        </v-card-title>
        <v-card-text>
          <!-- Row 1: Name, Upload, Current Image -->
          <v-row align="center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                dense
                label="Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <v-select
                v-model="form.parent_id"
                :items="parentTypes"
                item-text="name"
                item-value="id"
                outlined
                dense
                label="Parent Category (optional)"
                prepend-inner-icon="mdi-folder-outline"
                clearable
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4">
              <v-select
                v-model="form.app_route"
                :items="appRouteOptions"
                item-text="label"
                item-value="value"
                outlined
                dense
                label="App Route"
                prepend-inner-icon="mdi-routes"
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4">
              <v-file-input
                label="Upload new image"
                outlined
                dense
                type="file"
                v-model="image_path"
                placeholder="Upload the image here"
                hide-details
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="4" v-if="form.image_path && !image_path" class="d-flex flex-column align-center justify-center">
              <p class="text-caption grey--text mb-1">Current Image</p>
              <v-img
                :src="mediaUrl + form.image_path"
                max-width="80"
                max-height="80"
                contain
                class="rounded elevation-2"
              ></v-img>
            </v-col>
          </v-row>

          <!-- Row 2: Active switch -->
          <v-row align="center" class="mt-1">
            <v-col cols="12" sm="3">
              <v-switch
                v-model="form.is_active"
                :true-value="1"
                :false-value="0"
                label="Active"
                color="primary"
                inset
                hide-details
                class="mt-0 pt-0"
              ></v-switch>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col>
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                rounded
                color="primary"
                dark
                @click="save"
              >
                Save Product Type
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ProductTypeEditPage",
  data() {
    return {
      form: {
        name: "",
        is_active: 1,
        parent_id: null,
        app_route: "invoicing",
      },
      image_path: null,
      parentTypes: [],
      appRouteOptions: [
        { label: "Invoicing (Default)", value: "invoicing" },
        { label: "RMC Plant Listing", value: "rmc_plant" },
        { label: "RMC Plans", value: "rmc_plans" },
      ],
    };
  },
  mounted() {
    this.getData();
    axios.get("/product_types").then((r) => {
      this.parentTypes = (r.data.data || []).filter((t) => !t.parent_id);
    });
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.productTypeId;
      axios
        .get(`/product_types/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        const producttypeId = this.$route.params.productTypeId;
        await axios.patch(`/product_types/${producttypeId}`, this.form);
        if (this.image_path) {
          await this.handleFileUpload();
        }
        this.isLoading = false;
        await this.saveUserTimestamp(null, this.form);
        this.$router.push("/product-types");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      let formData = new FormData();
      formData.append("id", this.form.id);
      formData.append("image_path", this.image_path);
      await axios
        .post("product_types/upload_image_path", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
    },
  },
};
</script>
